const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const {CircleQuestionMark, CircleCheck} = require("lucide-react");
const CopyTable = require("../data/CopyTable");
const redeemSubscriptionErrorCopy = CopyTable.getFormInvalidCopy("redeemCode");
const redeemCodeCopy = CopyTable.getRedeemCodeStepCopy();
const styles = require("./styles/PageRedeemSubscription.css");

// Helper to apply higher-order components
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "CodeValidationBox",

		propTypes: {
			cart: PT.object.isRequired,
			onValidationStatusChange: PT.func.isRequired,
			checkCodesStatus: PT.string.isRequired,
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				code: this.props.cart?.redeemSubscriptionCode || "",
				error: null,
			};
		},

		componentDidMount: function() {
			if (this.state.code) {
				this.checkCode();
			}
		},

		vaultEvents: {
			verifyRedeemCodesSuccess: function(data) {
				if (data.valid) {
					this.props.onValidationStatusChange("complete", this.state.code);
				} else {
					this.props.onValidationStatusChange("", null);
					this.setState({
						error: data.errors[0].error,
					});
				}
			},
		},

		handleChange: function(e) {
			const newCode = e.target.value.trim().toUpperCase();
			this.setState(
				{
					code: newCode,
					error: null,
				},
				() => this.checkCode()
			);
		},

		checkCode: function() {
			const {code} = this.state;
			const invalidateCode = errorType => {
				this.setState({error: errorType ?? null});
				this.props.onValidationStatusChange("");
				return;
			};
			// Empty check
			if (!code) {
				invalidateCode();
				return;
			}
			// Length check (7 characters after the hyphen)
			if (code.includes("-") && code.split("-")[1].length > 7) {
				invalidateCode("E_INVALID_LENGTH");
				return;
			}
			// Only validates if the code is in the correct format
			if (code.match(/^[A-Z]+-[A-Z0-9]{7}$/)) {
				this.props.dispatch({
					type: AT.VERIFY_REDEEM_CODES_REQUEST,
					codes: [code],
				});
				return;
			}
			// If none of the above conditions are met, invalidate without error
			invalidateCode();
		},

		handleSubmit: function(e) {
			e.preventDefault();
			if (this.props.checkCodesStatus === "complete") {
				this.props.onValidationStatusChange("complete");
			}
		},

		render: function() {
			const {error} = this.state;
			const {checkCodesStatus} = this.props;

			return (
				<div className={styles.inputContainer}>
					<label className={styles.inputLabel} htmlFor="redemption-code">
						Subscription Code
					</label>
					<div className={styles.inputWrapper}>
						<input
							id="redemption-code"
							type="text"
							placeholder="Enter your code"
							value={this.state.code}
							onChange={this.handleChange}
							autoFocus
						/>
						<div className={styles.tooltipIcon}>
							<div className={styles.tooltipText}>{redeemCodeCopy.tooltip}</div>
							<CircleQuestionMark className={styles.circleQuestionIcon} />
						</div>
					</div>
					<div className={styles.statusMessage}>
						{error && (
							<div className={styles.errorMessage}>
								{redeemSubscriptionErrorCopy[error]}
							</div>
						)}
						{checkCodesStatus === "complete" && (
							<div className={styles.successMessage}>
								<span className={styles.checkmark}>
									<CircleCheck />
								</span>
								{redeemCodeCopy.codeRedeemSuccessMessage}
							</div>
						)}
					</div>
				</div>
			);
		},
	})
);
